export { HashAnchor } from './HashAnchor';
export type { HashAnchorProps } from './HashAnchor.types';
